import { createTitles, createAlias } from '@/router/routesHelper'

const Intro = () => import(/* webpackChunkName: "gt-intro-slide" */'@/components/Intro/Index')
const SlideRecruit = () => import(/* webpackChunkName: "gt-recruit-slide" */'@/components/Recruit/Index')
const SlideMember = () => import(/* webpackChunkName: "gt-discover-slide" */'@/components/Discover/Index')
const Story = () => import(/* webpackChunkName: "gt-stories" */'@/components/Story/Index')

export const discoverConfig = (() => {
    const alias = createAlias('discover')
    const titles = createTitles('discover')

    const routes = [{

        path: '/',
        name: 'intro',
        component: Intro

    }, {

        path: alias[0],
        name: 'slide',
        component: SlideMember,
        alias: alias.slice(1, alias.length)

    }, {

        path: `/discover-your-purple/:slug`,
        name: 'story',
        props: true,
        component: Story

    }]

    return {
        duration: 1.6,
        titles,
        alias,
        routes
    }
})()

export const recruitsConfig = (() => {
    const alias = createAlias('recruits', 'how-we-recruit')
    const titles = createTitles('recruits', 'How We Recruit')

    const routes  = [{
    
        path: alias[0],
        name: 'recruit-slide',
        component: SlideRecruit,
        alias: alias.slice(1, alias.length)

    }, {

        path: '/how-we-recruit-1/:slug',
        name: 'recruit-story',
        props: true,
        component: Story

    }]

    return {
        duration: 1.6,
        titles,
        alias,
        routes
    }
})()